import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b66435b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tachnical-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tachnical-title"
}, "技术原理", -1));
const _hoisted_3 = {
  class: "tachnical-content"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
import { ref } from 'vue';
export default {
  __name: 'technicalPrincipleCom',
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    imgUrlSmall: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    let pageActive = ref(false);
    __expose({
      pageActive
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: __props.imgUrl,
        alt: "",
        class: "back-big"
      }, null, 8, _hoisted_4), _createElementVNode("img", {
        src: __props.imgUrlSmall,
        alt: "",
        class: "back-small"
      }, null, 8, _hoisted_5)])]);
    };
  }
};